module.exports = __webpack_public_path__ + "media/images/business/design-timeline-mobile-4a562bd731b19a1e53c62eda3ce97440.svg";